<template lang="pug">
  td.col.favorite(:class="startingBusiness.favored ? 'on' : ''")
    span(@click="toggle") お気に入り
</template>

<script>
  import { mapActions } from 'vuex'
  import { HumanInfoMessages } from '../../constants'

  export default {
    props: ['startingBusiness', 'updateFavorForIndex'],
    data () {
      return {
        favored: this.startingBusiness.favored,
      }
    },
    methods: {
      ...mapActions('startingBusinessList', ['add', 'remove']),
      async toggle () {
        if (this.startingBusiness.favored) {
          this.$router.push({ name: 'StartingBusinessList' })
          return
        }

        this.$store.commit('common/lockGlobal')
        try {
          await this.add({ id: this.startingBusiness.id })

          if (this.updateFavorForIndex) {
            this.$store.commit('startingBusiness/favor', { ids: this.startingBusiness.id, newFavored: !this.startingBusiness.favored })
          }
          this.$store.dispatch('common/pushToastInfo', {
            info: HumanInfoMessages.ADDED_TO_STARTING_BUSINESS_LIST,
          })
          this.$emit('update')
        } catch (e) {
          this.$store.dispatch('common/pushToastError', {
            error: e,
          })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessTableFavoriteStar.vue